import { addToCart, updateCartGift, updateCart, ajaxCart } from './ajax-cart';
const $doc = $(document);

$doc.on('click', '.js-qty span', function() {
  const $this = $(this);
  const $parent = $this.parent();
  const $qtyInput = $parent.find('input');
  let qtyInputVal = $qtyInput.val();
  qtyInputVal = ($.isNumeric(qtyInputVal)) ? qtyInputVal : 0;
  const $form = $this.closest('form');
  const max = $qtyInput.data('max');

  // pz variant
  let $lineItem = null;
  if($(this).parents('.cart-item').length > 0) {
    $lineItem = $(this).parents('.cart-item');
  } else if($(this).parents('.cart-row').length > 0) {
    $lineItem = $(this).parents('.cart-row');
  }
  let pz_variant_id = '';
  if($lineItem != null) {
    pz_variant_id = $lineItem.data('pz');
  }
  let pz_qty = 0;
  if(pz_variant_id != '') {
    if($('#quantity-widget-' + pz_variant_id).length > 0) {
      pz_qty = $('#quantity-widget-' + pz_variant_id).val();
    } else if($('#quantity-default-' + pz_variant_id).length > 0) {
      pz_qty = $('#quantity-default-' + pz_variant_id).val();
    }
  }

  if ($this.hasClass('qty__btn--plus')) {
    qtyInputVal++;
    
    if (qtyInputVal > max) {
      return false;
    };

    qtyInputVal = (qtyInputVal < 0) ? 1 : qtyInputVal;
    pz_qty++;
  } else{
    qtyInputVal--;
    qtyInputVal = (qtyInputVal < 0) ? 0 : qtyInputVal;
    pz_qty--;
  }
  
  $qtyInput.val(qtyInputVal);
  
  const $itemsParent = $this.closest('.js-cart-items');

  if ($itemsParent.length) {
    $parent.addClass('qty--prevent');

    if ($parent.hasClass('js-qty--fake')) {
      const btnClass = this.className;
      const propTargetData = $parent.data('prop-qty');
      const $target = $itemsParent.find(`[data-prop-target][data-prop='${propTargetData}']`);

      $target.find(`.js-qty span[class="${btnClass}"]`).trigger('click');
    } else {
      const $rows = $itemsParent.find('[data-prop-target]');
      let rowsArr = [];
      const propTarget = $this.closest('[data-prop-target]').data('prop-target');

      $rows.each(function() {
        const $row = $(this);
        let rowQuantity = $row.find('.js-qty input').val();

        let _variant_id = $row.data('variant-id');
        if(pz_variant_id != '' && _variant_id == pz_variant_id) {
          rowQuantity = pz_qty;
        }

        if ((qtyInputVal == 0) && ($row.data('prop') == `${propTarget}`)) {
          rowQuantity = 0;
        } else if ($row.data('prop') == `${propTarget}`) {
          rowQuantity = qtyInputVal;
        }

        rowsArr.push(rowQuantity);
      });

      if ($this.closest('.js-widget-cart').length) {
        updateCartGift(rowsArr, true)
      }

      if ($this.closest('.js-section-cart').length) {
        updateCartGift(rowsArr, false);
      }
    }
  };
})



// WEBPACK FOOTER //
// ../assets/js/qty.js